class NullTexture {
		destroy(device) {}
		propertyChanged(flag) {}
		loseContext() {}
}

export { NullTexture };
